const transportationQuestionnaireEnum = Object.freeze({
    // section #2
    section_2_question_1_significant_impediment : 199, // question #1 - ¿Tiene el estudiante un impedimento significativo el cual requiere que se recoja directamente en su hogar?
    section_2_question_1_hasRegularTransport : 207, // question #1 - ¿Existe una ruta regular que sirva a la escuela donde estará ubicado el estudiante?
})

export default transportationQuestionnaireEnum;